import React from 'react';
import { APP_VERSION } from '../config/constants';

const AppVersion = ({ className = '' }) => (
  <span className={className ? `app-version ${className}` : 'app-version'}>
    v{APP_VERSION}
  </span>
);

export default AppVersion;
